import { useState, useEffect } from "react";

const useFetch = (url, token) =>{
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(() => !!url);
    const [error, setError] = useState(null);

    useEffect(()=>{
        const abortCont = new AbortController();

        if(!url){
            setData(null);
            setIsLoading(false);
            setError(null);
            return () => {};
        }

        setIsLoading(true);

        const headers = {};
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        fetch(url, { 
            signal: abortCont.signal,
            headers 
        })
        .then(res =>{
            if(!res.ok){
                throw Error('Could not fetch the data for that resource');
            };
            return res.json();
        })
        .then(data => {
            setData(data);
            setIsLoading(false);
        })
        .catch(err => {
            if(err.name !== 'AbortError'){
                setError(err.message);
                setIsLoading(false);
            }
        });

        return () => abortCont.abort();
    }, [url, token]);
    return { data, isLoading, error };
}

export default useFetch;
